import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-secondary-500/30 text-foreground-800">
      <div className="w-full px-4 sm:px-6 lg:px-10 py-10 md:py-14">
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-8">
          <div className="flex-1">
            <Link to="/" className="flex items-center gap-3 hover:opacity-70 transition-opacity duration-300">
              <img
                src="https://storage.readdy-site.link/project_files/1f18a76f-ed3f-4e88-bb38-b62c775c3336/dd8305a0-1fac-4e33-aa4a-430f46df46f4_ChatGPT-Image-Jun-9-2026-03_24_23-PM.png?v=ad55fcfd6c6876a070c9edc39cde37f1"
                alt="Serena's Quiet Recovery Space logo"
                title="Serena's Quiet Recovery Space - Private Alcohol Recovery Support"
                className="w-12 h-12 rounded-full object-cover"
              />
              <span className="font-heading text-lg md:text-xl font-medium text-foreground-950">
                Serena&apos;s Quiet Recovery Space
              </span>
            </Link>
            <p className="mt-3 text-sm font-body text-foreground-600 max-w-xs leading-relaxed">
              Private, supportive, non-judgemental alcohol recovery coaching. Helping you understand your relationship with alcohol and build a life that feels steadier, at your own pace.
            </p>
            <p className="mt-4 text-xs font-body text-foreground-500 max-w-xs leading-relaxed">
              This is a supportive coaching and educational space, not a substitute for emergency or medical care. If you are physically dependent on alcohol, please consult a healthcare professional.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-8 md:gap-16">
            <div>
              <h4 className="font-heading text-base font-medium text-foreground-900 mb-3">
                Navigate
              </h4>
              <ul className="flex flex-col gap-2">
                <li>
                  <Link
                    to="/"
                    onClick={() => window.scrollTo({ top: 0, behavior: "instant" })}
                    className="text-sm font-body text-foreground-600 hover:text-foreground-900 transition-colors duration-300"
                  >
                    Home
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about"
                    onClick={() => window.scrollTo({ top: 0, behavior: "instant" })}
                    className="text-sm font-body text-foreground-600 hover:text-foreground-900 transition-colors duration-300"
                  >
                    About Serena
                  </Link>
                </li>
                <li>
                  <Link
                    to="/course"
                    onClick={() => window.scrollTo({ top: 0, behavior: "instant" })}
                    className="text-sm font-body text-foreground-600 hover:text-foreground-900 transition-colors duration-300"
                  >
                    The Programme
                  </Link>
                </li>
                <li>
                  <Link
                    to="/support"
                    onClick={() => window.scrollTo({ top: 0, behavior: "instant" })}
                    className="text-sm font-body text-foreground-600 hover:text-foreground-900 transition-colors duration-300"
                  >
                    Coaching &amp; Support
                  </Link>
                </li>
                <li>
                  <Link
                    to="/blog"
                    onClick={() => window.scrollTo({ top: 0, behavior: "instant" })}
                    className="text-sm font-body text-foreground-600 hover:text-foreground-900 transition-colors duration-300"
                  >
                    Blog
                  </Link>
                </li>
                <li>
                  <Link
                    to="/resources"
                    onClick={() => window.scrollTo({ top: 0, behavior: "instant" })}
                    className="text-sm font-body text-foreground-600 hover:text-foreground-900 transition-colors duration-300"
                  >
                    Resources
                  </Link>
                </li>
                <li>
                  <Link
                    to="/faq"
                    onClick={() => window.scrollTo({ top: 0, behavior: "instant" })}
                    className="text-sm font-body text-foreground-600 hover:text-foreground-900 transition-colors duration-300"
                  >
                    FAQ
                  </Link>
                </li>
                <li>
                  <Link
                    to="/contact"
                    onClick={() => window.scrollTo({ top: 0, behavior: "instant" })}
                    className="text-sm font-body text-foreground-600 hover:text-foreground-900 transition-colors duration-300"
                  >
                    Contact
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base font-medium text-foreground-900 mb-3">
                Legal
              </h4>
              <ul className="flex flex-col gap-2">
                <li>
                  <Link
                    to="/faq"
                    className="text-sm font-body text-foreground-600 hover:text-foreground-900 transition-colors duration-300"
                  >
                    FAQ
                  </Link>
                </li>
                <li>
                  <a
                    href="mailto:hello@serenarecovery.com"
                    rel="nofollow"
                    className="text-sm font-body text-foreground-600 hover:text-foreground-900 transition-colors duration-300"
                  >
                    Privacy requests
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base font-medium text-foreground-900 mb-3">
                Get in touch
              </h4>
              <a
                href="mailto:hello@serenarecovery.com"
                rel="nofollow"
                className="text-sm font-body text-foreground-600 hover:text-foreground-900 transition-colors duration-300"
              >
                hello@serenarecovery.com
              </a>
              <div className="mt-3">
                <a
                  href="https://calendly.com/sraimes43/30min"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="inline-flex items-center gap-1.5 text-sm font-body text-foreground-600 hover:text-foreground-900 transition-colors duration-300 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-calendar-check-line text-base" />
                  Book a free call
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-300/40 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs font-body text-foreground-500">
            &copy; {new Date().getFullYear()} Serena&apos;s Quiet Recovery Space. All rights reserved.
          </p>
          <p className="text-xs font-body text-foreground-500">
            Private &bull; Supportive &bull; Non-judgemental
          </p>
        </div>
      </div>
    </footer>
  );
}